// extracted by mini-css-extract-plugin
var _1 = "ReviewItem_clickableArea__InwY2";
var _2 = "ReviewItem_content__9t0sV";
var _3 = "ReviewItem_item__Unc3Z";
var _4 = "ReviewItem_reviewText__LyuOB";
var _5 = "ReviewItem_thumbnailContainer__8-SPK";
var _6 = "ReviewItem_title__pY9iU";
var _7 = "ReviewItem_verifiedTag__akT4a";
export { _1 as "clickableArea", _2 as "content", _3 as "item", _4 as "reviewText", _5 as "thumbnailContainer", _6 as "title", _7 as "verifiedTag" }
